<content>
  <section class="entry-inline-framed">
    <label>{{'global.pais' | translate }}:</label> {{pais.des}}
    <label>{{'mantenimientoDenominaciones.paisDenominacion.marcas.denominacion' | translate }}</label> {{denominacion.des}}
  </section>
  <div class="table-wrapper-smaller" [ngClass]="{'m-bottom-bigger': marcasPaisDenominacion && marcasPaisDenominacion.length >= 1}">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="long">{{'mantenimientoDenominaciones.paisDenominacion.marcas.marca' | translate }}</th>
            <th class="long">{{'mantenimientoDenominaciones.paisDenominacion.marcas.etiquetasCaja' | translate }}</th>
            <th class="long">{{'mantenimientoDenominaciones.paisDenominacion.marcas.etiquetasPallet' | translate }}</th>
            <th class="long">{{'mantenimientoDenominaciones.paisDenominacion.marcas.destino' | translate }}</th>
            <th class="actions">
              <i class="fas fa-plus" (click)="new=true;editables=''" title="{{'mantenimientoDenominaciones.paisDenominacion.marcas.tituloNew' | translate}}"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <app-mpd-new-edit class="component-in-row" *ngIf="new" [editable]="true"
          [paisId]="paisId" [denominacionId]="denominacionId" (close)="new=$event" (refresh)="toRefresh($event)"
          (editableChanged)="editableChanged($event)" (pushMessage)="showMessages($event)"
          [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet">
          </app-mpd-new-edit>
          <app-mpd-new-edit class="component-in-row" *ngFor=" let marcaPaisDenominacion of marcasPaisDenominacion"
          [editable]="marcaPaisDenominacion === editables" (editableChanged)="editableChanged($event)" (pushMessage)="showMessages($event)"
          [marcaPaisDenominacion]="marcaPaisDenominacion" [paisId]="paisId" [denominacionId]="denominacionId"
          [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet" (refresh)="toRefresh($event)"
          [grupoEtiquetasCaja]="getGruposEtiqueta(marcaPaisDenominacion, 1)" [grupoEtiquetasPallet]="getGruposEtiqueta(marcaPaisDenominacion, 2)">
          </app-mpd-new-edit>
        </tbody>
        <tfoot *ngIf="!marcasPaisDenominacion || (marcasPaisDenominacion && marcasPaisDenominacion.length < 1)">
          <tr>
            <td colspan="5">
              {{'global.noContent' | translate}}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</content>
<footer class="button-bar-right">
  <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
